import { ArticlePhotoGroup } from '@/components/ArticlePhotoGroup';
import { Cell } from '@/design_system/Table/Table';
import { ShipmentWithRelations } from '@/models/shipment';

export const ArticlePhotoGroupCell = ({ shipment }: { shipment: ShipmentWithRelations }) => {
  return (
    <Cell>
      <ArticlePhotoGroup articles={shipment.articles.map(({ article }) => article)} />
    </Cell>
  );
};
